import { render, staticRenderFns } from "./add-maintenance.vue?vue&type=template&id=0b6998ee&scoped=true"
import script from "./add-maintenance.vue?vue&type=script&lang=js"
export * from "./add-maintenance.vue?vue&type=script&lang=js"
import style0 from "./add-maintenance.vue?vue&type=style&index=0&id=0b6998ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6998ee",
  null
  
)

export default component.exports